export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";